import { platforms, linkTarget } from '@/content/site.js';
import { PlatformGlyph } from '@/shared/glyphs.jsx';

export default function Download({ t }) {
  return (
    <section id="download" className="download">
      <div className="container">
        <div className="reveal sec-head">
          <div className="eyebrow">{t.eyebrow}</div>
          <h2>{t.title}</h2>
          <p>{t.lead}</p>
        </div>

        <div className="download-grid">
          {platforms.map((p) => {
            const copy = t.platforms[p.id];
            return (
              <a className="reveal download-card" href={p.href} {...linkTarget(p.href)} key={p.id}>
                <div className="download-glyph">
                  <PlatformGlyph name={p.key} size={30} />
                </div>
                <div className="download-name">{p.name}</div>
                <div className="download-meta">{copy.meta}</div>
                <div className="download-cta">{copy.cta}</div>
              </a>
            );
          })}
        </div>
        <div className="download-note">{t.note}</div>
      </div>
    </section>
  );
}
